import {ACTION_EVENTS} from "../UserAction";
import {ELEMENT_IDS} from "./DesktopDOM";
import GameAutostart from "../../game/GameAutostart";
import Wallet from "../../wallet/Wallet";

export default class DesktopAutostart {

    protected wrapper: HTMLElement;
    protected autostart: GameAutostart;
    protected wallet: Wallet;

    protected container: HTMLElement;
    protected defaultValues: Array<number> = [];
    protected values: Array<number> = [];
    protected disableAutostart: boolean;

    protected onClick: any = () => {};

    constructor(
        wrapper: HTMLElement,
        autostart: GameAutostart,
        wallet: Wallet
    ) {
        this.wrapper = wrapper;
        this.autostart = autostart;
        this.wallet = wallet;
    }

    create() {

        this.container = document.createElement("div");
        this.wrapper.appendChild(this.container);
        this.container.classList.add("mx-bar-autostart-menu");
        this.container.id = ELEMENT_IDS.AUTOSTART_MENU;
        $(this.container).hide();

        let values = this.autostart?.getValues();

        for (let val of values) {
            this.addValue(val);
            this.defaultValues.push(val);
        }

        let autostartX = document.createElement("button");
        autostartX.classList.add("mx-input", "mx-button", "mx-desk-autostart-btn", "mx-desk-btn-autostart-x");
        // $(autostartX).data("action", ACTION_EVENTS.ACTION_AUTOSTART_CLOSE);
        $(autostartX).data("action", ACTION_EVENTS.ACTION_AUTOSTART_CHOOSE);
        $(autostartX).data("data", 0);
        this.container.appendChild(autostartX);
    }

    addValue(val: number, isNew: boolean = false) {
        let btn = document.createElement("button");
        if (val === Infinity) {
            btn.classList.add("mx-input", "mx-button", "mx-desk-autostart-btn", "mx-desk-btn-autostart-inf");
            $(btn).data("action", ACTION_EVENTS.ACTION_AUTOSTART_CHOOSE);
            $(btn).data("data", Infinity);
        } else {
            btn.classList.add("mx-input", "mx-button", "mx-desk-autostart-btn", "mx-desk-btn-autostart");
            btn.textContent = val.toString();
            $(btn).data("action", ACTION_EVENTS.ACTION_AUTOSTART_CHOOSE);
            $(btn).data("data", val);
        }
        if (isNew) {
            $(btn).on("click", event => {
                this.onClick(event);
            });
        }
        this.container.appendChild(btn);
        this.values.push(val);
    }

    open() {
        $(this.container).show();
        if (this.wallet.isBonus() && !this.defaultValues.includes(this.wallet.getFreeSpins())) {
            this.addValue(this.wallet.getFreeSpins(), true);
        }
        $(this.container).children().each((key, item) => {
            // if playing for freespins, hide options that are bigger than amount of freespins
            if (this.wallet.isBonus() && this.wallet.getFreeSpins() < $(item).data("data")) {
                $(item).hide();
            } else {
                $(item).show();
            }
        });

        let autostartBtn = document.getElementById(ELEMENT_IDS.AUTOSTART_BTN);
        $(autostartBtn).data("action", ACTION_EVENTS.ACTION_AUTOSTART_CLOSE);
    }

    close() {

    }

    hide() {
        $(this.container).hide();

        $(this.container).children().each((key, item) => {
            $(item).show();
            let val = $(item).data("data");
            if (val && !this.defaultValues.includes(val) && val !== Infinity) {
                $(item).remove();
                this.values.splice(this.values.indexOf(val), 1);
            }
        });

        let autostartBtn = document.getElementById(ELEMENT_IDS.AUTOSTART_BTN);
        $(autostartBtn).data("action", ACTION_EVENTS.ACTION_AUTOSTART_OPEN);
    }

    setOnClick(click: any) {
        this.onClick = click;
    }
}
